import device from "@/api/device";
import {
  CORRECT_CARTRIDGE,
  ERROR_CARTRIDGE,
  getDeviceBattery,
  getDeviceLiquid,
  handleHexStringToUInt16,
  NO_CARTRIDGE,
} from "@/util";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    battery: 0,
    liquid: 0,
    maxSeconds: 0,
    currentSeconds: 0,
    flavorInfo: {formula: ""},
    sessionCartridgeStatus: 0,
    deviceInfo: {
      //device info in current session
      cartridgeId: "",//烟弹的tag
      deviceTag: "", //设备的tag
      deviceId: "",  //服务器的设备id
      uniqueId: 0,   //服务器的uniqueId
      status: 0, // 0 unregister || 1 自己registered || 2 其他人registered
      registerTime: "", //注册设备时间
      dd: ""
    },
  },
  mutations: {
    setBattery(state, battery) {
      state.battery = battery;
    },
    setLiquid(state, liquid) {
      state.liquid = liquid;
    },
    setMaxSecond(state, maxSeconds) {
      state.maxSeconds = maxSeconds;
    },
    setCurrentSeconds(state, currentSeconds) {
      state.currentSeconds = currentSeconds;
    },
    setFlavorInfo(state, liquid) {
      state.flavorInfo = liquid;
    },
    setSessionCartridgeStatus(state, status) {
      state.sessionCartridgeStatus = status;
    },
    setDeviceInfo(state, deviceInfo) {
      state.deviceInfo = {...state.deviceInfo, ...deviceInfo};
    },
  },
  getters: {},
  actions: {
    async changeRebindStatus({state, commit, rootState}, payload) {
      state.flavorInfo.bindDeviceToUserId = rootState.user.userInfo.id
      state.flavorInfo.bindDeviceStatus = 1
      state.deviceInfo.status = 1
    },
    async fetchBatteryAndLiquid({state, commit, rootState}, payload) {
      const {cartridgeId, deviceId, deviceParams} = payload;

      commit("setDeviceInfo", {
        deviceTag: deviceId,
        cartridgeId: cartridgeId,
        dd: deviceParams
      })
      if (deviceParams.length !== 12) {
        return {status: ERROR_CARTRIDGE, cartridgeId: ""};
      }

      commit("setBattery", getDeviceBattery(deviceParams.slice(0, 4)));
      if (cartridgeId.length < 8) {
        return {status: ERROR_CARTRIDGE, cartridgeId: ""}; // Invalid cartridge
      }

      const realCartridgeId = cartridgeId.substring(0, 8);
      if (realCartridgeId === "FFFFFFFF") {
        // Invalid Cartridge
        return {status: ERROR_CARTRIDGE, cartridgeId: realCartridgeId};
      }
      if (realCartridgeId === "00000000") {
        // No insert cartridge
        console.log(realCartridgeId === "00000000")
        return {status: NO_CARTRIDGE, cartridgeId: realCartridgeId};
      }

      if (rootState.user.token) {
        device.uploadScanRecord(
          handleHexStringToUInt16(deviceParams.slice(0, 4)),
          handleHexStringToUInt16(deviceParams.slice(4, 8)),
          handleHexStringToUInt16(deviceParams.slice(8, 12)),
          deviceId,
          realCartridgeId
        );
      }
      commit(
        "setLiquid",
        getDeviceLiquid(deviceParams.slice(4, 8), deviceParams.slice(8, 12))
      );
      const maxSecond = handleHexStringToUInt16(deviceParams.slice(8, 12))
      const currentSecond = handleHexStringToUInt16(deviceParams.slice(4, 8))
      commit("setMaxSecond", maxSecond)
      commit("setCurrentSeconds", currentSecond)
      return {status: CORRECT_CARTRIDGE, cartridgeId: realCartridgeId};
    },
    //cartridgeId 换弹的是cartridge 的tag，一次性的就是设备的tag
    //deviceId 换弹的是设备的tag
    async fetchFlavor({state, commit, rootState}, {cartridgeId, deviceId}) {
      const response = await device.productInfo({
        tagId: cartridgeId,
        deviceId,
      });
      if (process.env.VUE_APP_CUSTOMER === 'jzz') {
        response.data.popupType = 9
      }
      // response.data.popupType = 9
      const flavorInfo = response.data;
      flavorInfo.formula =
        (flavorInfo.formula && flavorInfo.formula[0].proportion) || "";

      commit("setFlavorInfo", flavorInfo);
      commit("setDeviceInfo", {
        cartridgeId,                    //烟弹的tag
        deviceTag: deviceId,            //设备的tag
        deviceId: flavorInfo.deviceId, //服务器的deviceId
        uniqueId: flavorInfo.uniqueId, //服务器的uniqueId
        // status: flavorInfo.bindDeviceStatus,
        status: flavorInfo.bindDeviceStatus === 0 ? 0 : flavorInfo.bindDeviceToUserId === rootState.user.userInfo.id ? 1 : 2,
      });
      return flavorInfo;
    },
    async registerCurrentSessionDevice({state, dispatch, commit, rootState}) {
      const {deviceId, cartridgeId, deviceTag} = state.deviceInfo;
      const registerDeviceResp = await device.registerDevice({deviceId, cartridgeMac: cartridgeId});
      await dispatch("fetchFlavor", {cartridgeId, deviceId: deviceTag})
      commit("setDeviceInfo", {
        status: 1, //change bind status when registered
        ...registerDeviceResp.data,
      });
      state.flavorInfo.bindDeviceToUserId = rootState.user.userInfo.id
      commit("setFlavorInfo", state.flavorInfo)
      await router.push({
        name: "MyDevices",
        params: {
          registered: true,
        },
      });
    },
    async directRegisterCurrentSessionDevice({state, dispatch, commit}) {
      const {deviceId, cartridgeId, deviceTag} = state.deviceInfo;
      const registerDeviceResp = await device.registerDevice({deviceId, cartridgeMac: cartridgeId});
      await dispatch("fetchFlavor", {cartridgeId, deviceId: deviceTag})
      commit("setDeviceInfo", {
        status: 1, //change bind status when registered
        ...registerDeviceResp.data,
      });
      await router.replace({
        name: "MyDevices",
        params: {
          registered: true,
        },
      });
    },

    updateBindStatus({commit, state, rootState}) {
      commit("setDeviceInfo", {
        ...state.deviceInfo,
        status: state.flavorInfo.bindDeviceStatus === 0 ? 0 : state.flavorInfo.bindDeviceToUserId === rootState.user.userInfo.id ? 1 : 2,
      });
    },
  },
};
